import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  @ViewChild("input1")
  input1Field!: ElementRef<HTMLInputElement>;
  @ViewChild("input2") input2Field!: ElementRef<HTMLInputElement> ;
  @ViewChild("input3") input3Field!: ElementRef<HTMLInputElement> ;
  @ViewChild("input4") input4Field!: ElementRef<HTMLInputElement> ;
  touchedInputs: boolean = false;
  input1: string = "";
  input2: string = "";
  input3: string = "";
  input4: string = "";
  validOtpLength : boolean= false;
  fetchedData: any;
  submitedOtp = false;
  responseOtp = false;
  submitedResendOtp = false;
  responseResendOtp = false;
  // input5: string = "";

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.fetchedData= this.dataService.objectDetails;
    console.log(this.fetchedData);
  }

  onKeyup(
    event: KeyboardEvent,
    currentInput: HTMLInputElement,
    nextInput: HTMLInputElement| null,
    prevInput: HTMLInputElement| null,
    position: string
  ) {
    this.touchedInputs =true
    console.log(event);
    const value = currentInput.value;
    if (!value.match(/[0-9]/)) {
      currentInput.value = "";
    } else {
      this.putApropriateValue(position, value);
      if (value.length === 1 && nextInput!=null) {
        nextInput.focus();
      }
    }
  }

  onBackspace(
    event: KeyboardEvent,
    currentInput: HTMLInputElement,
    prevInput: HTMLInputElement | null,
    position: string
  ) {
    if (event.key === "Backspace") {
      this.putApropriateValue(position, "");
      if (currentInput.value === "") {
        if (prevInput) {
          prevInput.focus();
        }
      }
    }
  }

  putApropriateValue(position: string, value: any) {
    switch (position) {
      case "1":
        this.input1 = value;
        break;
      case "2":
        this.input2 = value;
        break;
      case "3":
        this.input3 = value;
        break;
      case "4":
        this.input4 = value;
        break;
      default:
        console.log("No such Value");
        break;
    }
  }


  validateOTP() {
    const otpValue = this.input1 + this.input2 + this.input3 + this.input4;
    console.log(otpValue);
    this.submitedOtp = true;
   
    if (otpValue && otpValue.length === 4) {
      console.log("Valid OTP entered:", otpValue);
      const payload= {
        userId: this.fetchedData,
        OTP: otpValue,
      };

    


      // phoneNumber: "0782502474",
      // email: "his.fetchedData.email",
      // userId: "this.fetchedData.userId",
      this.authService.validateOTP(payload).subscribe(
        (response) => {
          if (response.success){
            this.responseOtp = true;
            this.cleanOTPFields()
            console.log("OTP VAlidation Response:", response);
            Swal.fire("OTP verified Successfully!", "Proceed to Login", "success").then(() => {
              this.router.navigate(["/login"]);
            });
          }else{
            Swal.fire("OTP VAlidation Failed!", response.message, "error");
          }
        },
        (error) => {
          this.responseOtp = true;
          this.cleanOTPFields()
          console.error("OTP VAlidation Error:", error);
          Swal.fire("OTP VAlidation Failed!", error, "error");
         
        }
      );
    } else {
      this.submitedOtp = false;
      this.validOtpLength= false;
      console.log("Invalid OTP entered");

    }
  }
  checkOTPLength(): boolean{
    const otpValue = this.input1 + this.input2 + this.input3 + this.input4;
    console.log(otpValue);
    if (otpValue && otpValue.length === 4) {
      return false;
    }else{
      return true;
    }
  }

  resendOtp(){
    this.submitedResendOtp = true;
    console.log("Using userId :",this.fetchedData);
    const payload= {
      userId: this.fetchedData
    };

     this.authService.resendOTP(payload).subscribe(
       (response) => {
        this.responseResendOtp = true;
        this.cleanOTPFields()
         console.log("OTP Resent Response:", response);
         Swal.fire("OTP Resend Successfully!", "Proceed to verify", "success")
       },
       (error) => {
        this.responseResendOtp = true;
        this.cleanOTPFields()
         console.error("OTP Resend Error:", error);
         Swal.fire("OTP Resend Failed!", error, "error");
      
       }
     );
    
  }

  cleanOTPFields(){
    this.input1Field.nativeElement.value = "";
    this.input2Field.nativeElement.value = "";
    this.input3Field.nativeElement.value = "";
    this.input4Field.nativeElement.value = "";
  }
}
